<template lang="pug">
  h1.logo
    a(:href="href")
      img(:src="brand", :alt="title")

</template>

<script>
  export default  {
    name: 'logo',
    props: {
      brand: {
        type: String,
        default: 'assets/images/logos/mtonline.svg'
      },
      title: {
        type: String,
        default: 'MTOnline'
      },
      href: {
        type: String,
        default: 'http://mtonline.latercera.com'
      }
    }
  }
</script>

<style scoped lang="postcss">
  .logo {
    min-width: 100px;
    max-height: 40px;
    margin: 3px 0 0;
  }
</style>
